import { Stack, Table } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { t } from 'i18next';

import { NoContentPlaceholder } from '@/core/components';

import { Id } from '@/feature/utils';

import { getJournalImpactFactorMetricOptions } from './model/JournalQuery';

interface JournalImpactFactorMetricTableProps {
  journalId: Id;
}

export function JournalImpactFactorMetricTable({ journalId }: JournalImpactFactorMetricTableProps) {
  const { data: metrics } = useSuspenseQuery(getJournalImpactFactorMetricOptions(journalId));

  return (
    <Stack>
      {metrics.length === 0 && <NoContentPlaceholder title={t('journals.reputation.noData')} />}

      {metrics.length != 0 && (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t('journals.reputation.impactFactor.metric.tableHeader.impactFactor')}</Table.Th>
              <Table.Th>
                {t('journals.reputation.impactFactor.metric.tableHeader.impactFactorWithoutSelfCitations')}
              </Table.Th>
              <Table.Th>{t('journals.reputation.impactFactor.metric.tableHeader.impactFactor5Years')}</Table.Th>
              <Table.Th>{t('journals.reputation.impactFactor.metric.tableHeader.year')}</Table.Th>
              <Table.Th>{t('journals.reputation.impactFactor.metric.tableHeader.suppressed')}</Table.Th>
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {metrics.map(item => (
              <Table.Tr key={item.id}>
                <Table.Td>{item.impactFactor}</Table.Td>
                <Table.Td>{item.impactFactorWithoutSelfCitations}</Table.Td>
                <Table.Td>{item.impactFactor5Years}</Table.Td>
                <Table.Td>{item.year}</Table.Td>
                <Table.Td>
                  <input
                    type="checkbox"
                    checked={item.suppressed}
                    disabled
                  ></input>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Stack>
  );
}
